import type { InviteDetails, InviteDetailsDto } from './auth.dto';

export const mapInviteDetails = ({
  contact_type,
  first_name,
  ...values
}: InviteDetailsDto): InviteDetails => ({
  ...values,
  contactType: contact_type,
  firstName: first_name,
});
